'use strict';


export const setQuery = (state, query) => { state.query = query };

//=================================================================================================================

export const setResults = (state, results) => { state.results = results };
